<div class="logs-signpost-custom-e2e-timing">
    <ng-content></ng-content>

    <logs-signpost-custom-e2e-timing-header
        (onSwitchView)="switchView($event)"
    ></logs-signpost-custom-e2e-timing-header>
    <logs-signpost-custom-e2e-timing-data-grid></logs-signpost-custom-e2e-timing-data-grid>
</div>

<div
    *ngIf="(trafficLogsSignpostStore.isLoading$ | async) && !(trafficLogsSignpostStore.logsEndToEndTimingSignpostData$ | async)"
    class="logs-signpost-custom-e2e-timing__loader clr-wrapper"
>
    <clr-spinner [clrMedium]="true"></clr-spinner>
</div>
